import { observer } from 'mobx-react';
import { FC, ReactElement, useMemo } from 'react';
import ColorsBlock from '../../../../containers/ColorsBlock/ColorsBlock';
import configKioskStore from '../../store';
import { IConfigKioskColorRow } from '../../types';
import { localeStore } from 'src/mobx/localesStore';

const KioskConfigColorsTab: FC = observer((): ReactElement => {
  const { focusField, isFocusFieldValue, colorsValidation, changeColors, setFocusField } = configKioskStore;

  // const changeTheme = useCallback((value: Theme) => {
  //   changeColors({ theme: value });
  // }, []);

  // const themePickerOptions = useMemo((): IPickerOption[] => {
  //   return [
  //     { value: Theme.LIGHT, label: localeStore.t(`${Theme.LIGHT}_theme`) },
  //     { value: Theme.DARK, label: localeStore.t(`${Theme.DARK}_theme`) },
  //   ];
  // }, []);

  const colorsRows = useMemo((): IConfigKioskColorRow[] => {
    return [{ field: 'mainColor', title: localeStore.t('main_color') }];
  }, []);

  return (
    <div className="d-flex flex-column">
      {/* <TabPicker value={configKioskStore.colors.theme} options={themePickerOptions} onChange={changeTheme} className="width-fit" /> */}
      <ColorsBlock
        rows={colorsRows}
        values={configKioskStore.colors}
        focusField={focusField}
        focusFieldValue={isFocusFieldValue}
        changeColors={changeColors}
        setFocusField={setFocusField}
        submit={configKioskStore.submit}
        validation={colorsValidation}
      />
    </div>
  );
});

export default KioskConfigColorsTab;
